module.exports = __webpack_public_path__ + "static/front/img/instagram4.baa2b912.jpg";